<ng-template #customModalTemplate>
  <div
    [ngClass]="dynamicClass"
    class=""
    tabindex="-1"
    role="dialog"
    aria-labelledby="dialog-sizes-name1"
  >
    <div
      class="modal-header ps-4 d-flex justify-content-between"
      *ngIf="headerLabel"
    >
      <h4 class="modal-title">
        {{ headerLabel }}
      </h4>
    </div>
    <hr *ngIf="headerLabel" class="modal-break-line" />
    <div class="">
      <div class="modal-content admin-modaldialog modal-basic text-center confirmation-modal-content">
        <div class="modal-body" [innerHTML]="ConfirmationMessage"></div>
        <div
          class="modal-footer"
          [ngClass]="{ 'confirm-content-action': !isDeleteModal }"
        >
          <button
            [ngClass]="[isDeleteModal ? 'btn btn-primary' : 'btn btn-default']"
            (click)="onCancel()"
          >
            {{ commonEnum.NO }}
          </button>
          <button
            (click)="onConfirm()"
            [ngClass]="[!isDeleteModal ? 'btn btn-primary' : 'btn btn-default']"
          >
            {{ commonEnum.YES }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
